module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__scotiabank.c7221994.svg";